/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { CheckIconModal } from '../CheckIconModal'

function DefaultDescription() {
  return (
    <Trans
      i18nKey="upsell.campaign_download.exit_description"
      components={{ strong: <strong /> }}
    />
  )
}

function wrapExitAction(
  action,
  selectedFeedback,
  { requireSelection = true, onExitWithFeedback } = {},
) {
  if (!action) {
    return undefined
  }

  const hasSelection = !!selectedFeedback

  if (!requireSelection) {
    return action
  }

  return {
    ...action,
    disabled: !hasSelection || action.disabled,
    onClick: () => {
      if (!hasSelection) {
        return
      }

      onExitWithFeedback?.(selectedFeedback)
      action.onClick?.(selectedFeedback)
    },
  }
}

export const ExitFeedbackModal = ({
  isOpen,
  onClose,
  title,
  description,
  feedback,
  primaryAction,
  secondaryAction,
  backAction,
  onExitWithFeedback,
  showCheckIcon = true,
  showCloseButton = true,
}) => {
  const { t } = useTranslation()
  const [selectedFeedback, setSelectedFeedback] = useState(null)
  const resolvedSecondaryAction = secondaryAction ?? backAction

  useEffect(() => {
    if (!isOpen) {
      setSelectedFeedback(null)
    }
  }, [isOpen])

  return (
    <CheckIconModal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? t('upsell.modals.exit_feedback_title')}
      titleId="exit-feedback-modal-title"
      description={description ?? <DefaultDescription />}
      feedback={
        feedback
          ? {
            ...feedback,
            question:
                feedback.question ?? t('upsell.modals.exit_feedback_question'),
            selectedId: selectedFeedback?.id ?? null,
            onSelect: (option) => {
              setSelectedFeedback(option ?? null)
              if (option) {
                feedback.onSelect?.(option)
              }
            },
          }
          : null
      }
      primaryAction={wrapExitAction(primaryAction, selectedFeedback, {
        requireSelection: false,
      })}
      secondaryAction={wrapExitAction(resolvedSecondaryAction, selectedFeedback, {
        onExitWithFeedback,
      })}
      showCloseButton={showCloseButton}
      showCheckIcon={showCheckIcon}
    />
  )
}

export default ExitFeedbackModal
